
(function () {
    'use strict';

    if (window.__productThumbsPaginationLoaded__) return;
    window.__productThumbsPaginationLoaded__ = true;

    const SELECT_EVENT = 'theme:media:select'; 
    const ACTIVE_MEDIA_ATTR = 'data-active-media';
    const MEDIA_ID_ATTR = 'data-media-id';
    const THUMB_ITEM_SEL = '[data-thumb-item]';
    const THUMB_LINK_SEL = '[data-thumb-link]';
    const PAGINATION_WRAP_SEL = '.product-gallery__pagination';
    const PAGINATION_DOT_SEL = '.pagination-dot';
    const ACTIVE_DOT_CLASS = 'active';
    enhanceAll();
    document.addEventListener('shopify:section:load', enhanceAll);
    document.addEventListener('shopify:section:reorder', enhanceAll);
    document.addEventListener('shopify:section:unload', cleanupDetached);

    function enhanceAll() {
        document.querySelectorAll('product-thumbs').forEach((thumbsEl) => {
            const sectionEl = thumbsEl.closest('[data-section-type]');
            if (!sectionEl) return;

            const paginationEl = sectionEl.querySelector(PAGINATION_WRAP_SEL);
            if (!paginationEl) return;

            if (paginationEl.dataset.paginationSynced === 'true') return;
            paginationEl.dataset.paginationSynced = 'true';

            const productImagesContainer = findImagesContainer(sectionEl);
            if (!productImagesContainer) return;

            const thumbLinks = [...thumbsEl.querySelectorAll(THUMB_LINK_SEL)];
            const indexToMediaId = thumbLinks.map((n) => n.getAttribute(MEDIA_ID_ATTR));
            const mediaIdToIndex = {};
            indexToMediaId.forEach((id, i) => {
                if (id) mediaIdToIndex[id] = i;
            });

            const dots = [...paginationEl.querySelectorAll(PAGINATION_DOT_SEL)];
            dots.forEach((dot) => {
                dot.addEventListener('click', () => {
                    const idx = Number(dot.dataset.index);
                    const mediaId = indexToMediaId[idx];
                    if (!mediaId) return;
                    dispatchSelect(sectionEl, mediaId);
                });
            });

            // Sync via MutationObserver on data-active-media (desktop thumb clicks)
            const mo = new MutationObserver(() =>
                syncActiveDotFromAttr(paginationEl, productImagesContainer, mediaIdToIndex, dots),
            );
            mo.observe(productImagesContainer, { attributes: true, attributeFilter: [ACTIVE_MEDIA_ATTR] });

            // Also sync when the theme dispatches theme:media:select (mobile carousel swipe)
            const onMediaSelect = (e) => {
                const mediaId = e.detail && e.detail.id;
                if (!mediaId) return;
                const idx = mediaIdToIndex[mediaId];
                if (idx == null) return;
                setActiveDot(paginationEl, dots, idx);
            };
            sectionEl.addEventListener('theme:media:select', onMediaSelect);

            // Sync via scroll position for CSS scroll-snap carousel (mobile)
            const slidesEl = sectionEl.querySelector('[data-product-media-list]');
            let scrollTimer;
            const onSlideScroll = () => {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(() => {
                    if (!slidesEl) return;
                    const slideWidth = slidesEl.scrollWidth / (thumbLinks.length || 1);
                    const idx = Math.round(slidesEl.scrollLeft / slideWidth);
                    setActiveDot(paginationEl, dots, idx);
                }, 50);
            };
            if (slidesEl) slidesEl.addEventListener('scroll', onSlideScroll, { passive: true });

            paginationEl.__thumbsPagObserver = mo;
            paginationEl.__thumbsPagMediaSelect = onMediaSelect;
            paginationEl.__thumbsPagScrollEl = slidesEl;
            paginationEl.__thumbsPagOnScroll = onSlideScroll;
            paginationEl.__thumbsPagSectionEl = sectionEl;

            requestAnimationFrame(() =>
                syncActiveDotFromAttr(paginationEl, productImagesContainer, mediaIdToIndex, dots),
            );
        });
    }

    function findImagesContainer(sectionEl) {
        let el = sectionEl.querySelector('.product-images');
        if (el) return el;
        el = sectionEl.querySelector(`[${ACTIVE_MEDIA_ATTR}]`);
        return el || null;
    }

    function dispatchSelect(sectionEl, mediaId) {
        sectionEl.dispatchEvent(
            new CustomEvent(SELECT_EVENT, {
                bubbles: true,
                detail: { id: mediaId },
            }),
        );
    }

    function syncActiveDotFromAttr(paginationEl, imagesContainer, mediaIdToIndex, dots) {
        const activeMediaId = imagesContainer.getAttribute(ACTIVE_MEDIA_ATTR);
        if (!activeMediaId) return;
        const idx = mediaIdToIndex[activeMediaId];
        if (idx == null) return; 
        setActiveDot(paginationEl, dots, idx);
    }

    function setActiveDot(paginationEl, dots, idx) {
        const current = paginationEl.querySelector(`.${ACTIVE_DOT_CLASS}`);
        if (current) current.classList.remove(ACTIVE_DOT_CLASS);
        const dot = dots[idx];
        if (dot) dot.classList.add(ACTIVE_DOT_CLASS);
    }
    function cleanupDetached(evt) {
        const container = evt.detail?.sectionElement;
        if (!container) return;
        const paginations = container.querySelectorAll(PAGINATION_WRAP_SEL);
        paginations.forEach((p) => {
            p.__thumbsPagObserver?.disconnect();
            if (p.__thumbsPagMediaSelect && p.__thumbsPagSectionEl) {
                p.__thumbsPagSectionEl.removeEventListener('theme:media:select', p.__thumbsPagMediaSelect);
            }
            if (p.__thumbsPagScrollEl && p.__thumbsPagOnScroll) {
                p.__thumbsPagScrollEl.removeEventListener('scroll', p.__thumbsPagOnScroll);
            }
            delete p.__thumbsPagObserver;
            delete p.__thumbsPagMediaSelect;
            delete p.__thumbsPagScrollEl;
            delete p.__thumbsPagOnScroll;
            delete p.__thumbsPagSectionEl;
            delete p.dataset.paginationSynced;
        });
    }
})();
  